import React from 'react';
import './FloatingLabel.css';

const FloatingSelectIdentity = ({ label, options, value, onChange, ...props }) => {
  const id = `floating-select-id`;

  return (
    <div 
    id={id}
    className="float-label-select">
      <select
        
        value={value}
        onChange={onChange}
        {...props}
      >
        {/* Empty default option */}
        <option value="" disabled hidden></option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {/* Floating label */}
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default FloatingSelectIdentity;

